import {
  TApiPricingResponse,
  TInvoiceConfigResponse,
} from '../../../coreGlobal/models/franchise/franchise'
import {formatDate} from '../../../utils/dayJs/format'
import {formatMonetaryToBr} from '../../../utils/formatMonetaryToBr'

type TServiceAmountProps = {
  invoiceConfig?: TInvoiceConfigResponse
  apiPricing: TApiPricingResponse
}
export const ServiceAmount = ({invoiceConfig, apiPricing}: TServiceAmountProps) => {
  return (
    <>
      <div
        className='tab-pane fade show active p-4 pt-0 pt-md-4'
        id='pills-data-partnership'
        role='tabpanel'
        aria-labelledby='pills-checklist-tab'
      >
        <div className='card mb-5 mb-xl-10'>
          <>
            <div className='card-header cursor-pointer'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>Configuraçao</h3>
              </div>
            </div>
            <div className='card-body py-3'>
              <div className='card-body p-9'>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-semibold text-muted'>Período de cobrança</label>
                  <div className='col-lg-8'>
                    <span className='fw-bold fs-6 text-gray-800'>
                      {invoiceConfig?.billingPeriod}
                    </span>
                  </div>
                </div>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-semibold text-muted'>
                    Data de vencimento da fatura
                  </label>
                  <div className='col-lg-8'>
                    <span className='fw-bold fs-6 text-gray-800'>
                      {invoiceConfig?.invoiceDueDay}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
      <div
        className='tab-pane fade show active p-4 pt-0 pt-md-4'
        id='pills-data-partnership'
        role='tabpanel'
        aria-labelledby='pills-checklist-tab'
      >
        <div className='card mb-5 mb-xl-10'>
          <>
            <div className='card-header cursor-pointer'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>Valor Serviço</h3>
              </div>
            </div>
            <div className='card-body py-3'>
              <div className='card-body p-9'>
                <table className='table table-row-dashed table-row-gray-300'>
                  <thead>
                    <tr className='fw-bolder fs-6 text-gray-800'>
                      <th></th>
                      <th>Descrição</th>
                      <th>Preço por solicitação</th>
                      <th>Valido apartir</th>
                      <th>Obs</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(apiPricing) &&
                      apiPricing?.map((field, index) => (
                        <tr key={`serviceAmount${index}`}>
                          <td>{field?.id}</td>
                          <td>{field?.endpoint}</td>
                          <td>{formatMonetaryToBr(field?.pricePerRequest)}</td>
                          <td>{formatDate(field?.validFrom)}</td>
                          <td>{field?.notes}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  )
}
